<template>
  <div>
    <v-form
      ref="formNew"
      @submit.prevent="onSubmitNew"
      v-model="validnew"
      @keydown.enter="onSubmitNew"
      id="login-form-new"
    >
      <v-layout column wrap mb-3>
        <v-layout column wrap>
          <v-flex xs12>
            <v-text-field
              dir="auto"
              rounded
              v-model="userNameNew"
              outlined
              solo
              :rules="nameRules"
              type="text"
              label="שם פרטי"
              prepend-inner-icon="mdi-account"
              class="text-field-input"
              required
              dense
            />
          </v-flex>
        </v-layout>

        <v-layout column wrap>
          <v-flex xs12>
            <v-text-field
              dir="auto"
              rounded
              v-model="lastNameNew"
              outlined
              solo
              :rules="nameRules"
              type="text"
              label="שם משפחה"
              prepend-inner-icon="mdi-account"
              class="text-field-input"
              required
              dense
            />
          </v-flex>
        </v-layout>

        <v-layout mt-1 column>
          <v-flex xs12 class="email-new-wrapper">
            <v-text-field
              v-model="emailNew"
              outlined
              rounded
              solo
              :rules="emailRules"
              type="text"
              label="דואר אלקטרוני"
              prepend-inner-icon="mdi-email-outline"
              class="text-field-input"
              ref="emailNewField"
              required
              :disabled="showSpinner"
              @keyup="alertError = false"
              @blur="validateUserExists"
              @focus="isUserFocus = true"
              @input="emailValidationNew = ''"
              @cut.prevent
              @copy.prevent
              autocomplete="new-email"
              dense
              :error-messages="emailValidationErrorMsg"
              dir="auto"
            />
            <!--  @cut.prevent   @copy.prevent -->
            <SmallSpinner v-show="showSpinner" class="SmallSpinner" />
          </v-flex>
        </v-layout>
        <v-layout mt-1 column>
          <v-flex xs12 class="email-new-wrapper">
            <v-text-field
              v-model="emailValidationNew"
              outlined
              rounded
              solo
              :rules="emailValidationRules"
              type="text"
              label="הקלד שנית לצורך אימות"
              prepend-inner-icon="mdi-email-outline"
              class="text-field-input"
              ref="emailValidationField"
              required
              :disabled="!isEmailValid || showSpinner"
              autocomplete="new-email"
              dense
              dir="auto"
              @paste.prevent
            />
            <!-- @paste.prevent -->
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-text-field
              v-model="passwordNew"
              rounded
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
              :type="show2 ? 'text' : 'password'"
              solo
              :rules="passwordRules"
              outlined
              label="סיסמה (6תווים)"
              prepend-inner-icon="mdi-lock"
              required
              clearable
              dense
            />
          </v-flex>
        </v-layout>

        <v-layout column wrap>
          <v-flex x12>
            <PhoneNumberField
              :fieldClass="`text-field-input`"
              @updateNumber="applyNewPhone"
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex x12 mb-5>
            <LocationFieldNew @updateLocation="applyNewAddress" />
          </v-flex>
        </v-layout>

        <v-layout column wrap>
          <v-flex xs12>
            <v-checkbox
              v-model="rememberMe"
              color="orange"
              class="mt-0"
              hide-details
              light
              label="זכור אותי"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 wrap>
            <TermsField @newTerms="acceptTerms" />
          </v-flex>
        </v-layout>

        <v-layout wrap justify-center>
          <v-flex text-center>
            <v-btn
              id="submit-login-btn2"
              type="submit"
              :loading="process"
              :disabled="!validnew || !terms"
              class="orange_btn_large"
              @keydown.enter="onSubmitNew"
            >
              הרשם
            </v-btn>
          </v-flex>

          <v-col cols="12" class="pa-0 ma-0" v-if="signupError">
            <p class="pa-0 ma-0 text-center red--text">
              {{ signupErrorMsg }}
            </p>
          </v-col>
        </v-layout>
      </v-layout>
    </v-form>
  </div>
</template>


<script>
/**
 *  @todo - large template - split it
 */

import SmallSpinner from '@/components/Spinner/SmallSpinner';
import LocationFieldNew from '@/components/Forms/Form_Fields/LocationFieldNew';
import PhoneNumberField from '@/components/Forms/Form_Fields/PhoneNumberField';
import TermsField from '@/components/Forms/Form_Fields/TermsField';
import CurrentUser from '@/components/mixins/CurrentUser';
import recaptchaV3 from '@/components/mixins/recaptchaV3';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import errors from '@/lib/errorsList';
import gtm from '@/lib/gtm';
import { nameRules, emailRules, passwordRules } from '@/lib/rules.js';
import { SIGN_UP, VERIFY_EMAIL } from '@/lib/api.js';

export default {
  name: 'FormSignup',
  mixins: [CurrentUser, recaptchaV3],
  components: {
    SmallSpinner,
    LocationFieldNew,
    PhoneNumberField,
    TermsField
  },

  props: {
    page: {
      type: String,
      default: '1',
      required: false
    },
    redirectBack: {
      type: Boolean,
      required: false,
      defalut: false
    },
    activateOtpOnPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      show2: false,
      isUserFocus: false,
      process: false,
      valid: false,
      validnew: false,
      menu: false,
      showStar: true,
      showStar2: false,
      showStar3: false,
      emailValidationErrorMsg: '',
      nameRules,
      emailRules,
      passwordRules,
      // *

      Popover: {
        title: t('titles.personalAreaConnect'),
        titleLogged: t('titles.personalAreaTitle'),
        recruiterBtnTxt: t('titles.recruiterTitle'),
        userBtnTxt: t('titles.lookingForJob')
      },
      loginError: false,
      loginErrorMsg: 'שם משתמש או סיסמה שגויים.נסה/י שוב',
      signupErrorMsg: 'שגיאת רישום',
      signupError: false,
      alertError: '',
      isDismissible: false,
      showSpinner: false,
      UserExists: false,
      emailNew: '',
      emailValidationNew: '',
      passwordNew: '',
      phoneNum: undefined,
      cityId: null,
      userNameNew: '',
      lastNameNew: '',
      terms: false,
      rememberMe: true,
      email: '',
      password: '',
      emailValidationRules: [v => !!v && this.checkEmailValidation()],
      passedValidation: false
    };
  },
  created() {
    this.emailNew = '';
  },

  computed: {
    isEmailValid() {
      return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(
        this.emailNew
      );
    }
  },

  methods: {
    checkEmailValidation() {
      if (this.emailValidationNew.localeCompare(this.emailNew)) {
        return t('titles.errorMessages.emailValidationFailed');
      } else {
        return true;
      }
    },
    acceptTerms(boolVal) {
      this.terms = boolVal;
    },

    formNewReset() {
      this.$nuxt.$loading.finish();
      this.process = false;
      this.signupError = true;
    },

    applyNewPhone(number) {
      this.phoneNum = number;
    },

    applyNewAddress(address) {
      this.cityId = address ? address.Code : null; // NOT_RELEVANT_LOCATION
    },

    async onSubmitNew() {
      if (this.$refs.formNew.validate()) {
        this.process = true;
        const data = {
          FirstName: this.userNameNew,
          LastName: this.lastNameNew,
          AgreeToTerms: this.terms,
          Email: this.emailNew,
          Password: this.passwordNew,
          RememberMe: this.rememberMe,
          CityId: this.cityId ? this.cityId : 1201,
          Phone: this.phoneNum,
          Source: this.page,
          FullSignUp: true
        };

        this.$nuxt.$loading.start();

        try {
          const recaptcha = await this.recaptchaCheck('signup');
          if (!recaptcha) {
            throw new Error('Recaptcha failed');
          }
          const response = await this.$axios.post(`${SIGN_UP}`, data);

          if (response.data.IsError || response.data.Token === '') {
            let errorMessage =
              errors[Object.keys(response.data.ErrorsMessages)[0]];
            this.signupErrorMsg = errorMessage;
            throw errorMessage;
          }

          gtm({
            ID: response.data.RegistrationSource.RegistrationIdentifier,
            registration: response.data.RegistrationSource.Source,
            event: 'leadcrmregistration'
          });

          /**
           * gtm from @/lib/gtm'
           *  @param  {data} the gtm dataLayer
           */
          gtm({
            event: 'gtm.dom',
            'gtm.uniqueEventId': 3
          });
          gtm({
            event: 'registration',
            category: 'registration'
          });

          gtm({
            email: this.emailNew,
            phone: this.phoneNum,
            event: 'registration_gads'
          });

          // await this.updateVeuxStore(response.data.Token);
          const { Email } = response.data.UserProfile;
          const { Token } = response.data;
          const userData = {
            email: Email,
            token: Token,
            password: this.passwordNew,
            rememberMe: this.rememberMe
          };

          this.$nuxt.$emit('openOTP', 'default', userData);
          this.clearForm();

          // if (this.activateOtpOnPage) {
          //   this.$nuxt.$emit('openOTP', 'signup');
          // }
          // perform update smartagent step status
          let pathname = this.$route.path;
          if (pathname === '/smartalerts.aspx') {
            this.$nuxt.$emit('next-step');
          }

          if (this.page === '4') {
            //emit an event to show cv box
            gtm({
              event: 'goal_17_completion'
            });
            //emit an event to show cv box
            this.$emit('showCVForm');
          }
          if (this.redirectBack) {
            setTimeout(() => {
              this.$router.back();
            }, 500);
          }

          this.$nuxt.$loading.finish();
        } catch (e) {
          console.log(e);
          this.formNewReset();
        }
      }
    },

    /**
     * valitade user email on @blur and update this.UserExists on true
     * @this.emailNew send to endpoint
     * @todo share validateUserExists between components
     */
    async validateUserExists() {
      if (!this.isUserFocus) {
        return;
      }
      this.emailValidationErrorMsg = '';

      if (this.emailNew.length > 3) {
        this.showSpinner = true;
        const emailToVerify = encodeURIComponent(this.emailNew);
        try {
          const response = await this.$axios.get(
            `${VERIFY_EMAIL}?email=${emailToVerify}`
          );

          let isError = response.data.IsError;

          if (isError) {
            let errorMessage =
              errors[Object.keys(response.data.ErrorsMessages)[0]];

            this.emailValidationErrorMsg = errorMessage;
            this.alertError = true;
            this.showSpinner = false;
          } else {
            this.showSpinner = false;
            this.alertError = false;
          }
        } catch (error) {
          console.warn(error);
        }
      }
    },

    clearForm() {
      this.$refs.formNew.reset();
      this.$nuxt.$loading.finish();
      this.signupError = false;
      this.process = false;
      this.validnew = false;
      this.initFormFlags();
      this.$emit('close-menu');
      this.$nuxt.$emit('openOTP', 'after-signup');
    },
    initFormFlags() {
      this.$nextTick(() => {
        this.rememberMe = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.text-field-input,
.email-new-wrapper {
  position: relative;
}

.v-btn__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
  color: #ff7100;
  transform: translateY(5px) !important;
  place-content: flex-end;
}

.theme--light.v-sheet {
  background-color: #fff;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  margin: 0 auto;
}

.v-btn:focus:before {
  background-color: transparent;
}

@media screen and (max-width: 480px) {
  @media screen and (max-width: 600px) {
    input {
      font-size: 12px;
    }

    .login-menu-wrapper .theme--light.v-input:not(.v-input--is-disabled) input,
    .theme--light.v-input:not(.v-input--is-disabled) textarea {
      padding: 2px;
    }
  }
}
@media screen and (max-width: 400px) {
  .theme--light.v-sheet {
    width: 100%;
  }
}
</style>
